/** Platform admin: audit screen (P9). Owned by the audit screen; fil mirrors every key. */
export const audit = {
  title: "Audit logs",
  subtitle: "Every privileged action by CRUD.IT staff, tenant admins and system jobs across the platform.",
  verify: "Verify hash chain",
  export: "Export",
  exportCsv: "CSV (current filters)",
  exported: "Audit export downloaded · {{file}}",
  integrity: {
    title: "Append-only · hashed chain.",
    body: "Entries can't be edited or deleted. Each row stores sha256(prev_hash ‖ payload), so any change breaks the chain; Verify recomputes it for the selected scope.",
    unverified: "Not verified yet",
    verifying: "Verifying…",
    intact: "Chain intact",
    broken: "Chain broken",
    verified: "Verified {{formatted}} events · {{scope}} chain intact",
    brokenToast: "Hash chain broken at event #{{seq}} — escalate to security",
    platformScope: "platform",
    tenantScope: "tenant",
  },
  scope: {
    label: "Chain",
    all: "All events",
    platform: "Platform chain",
    tenant: "Tenant chain",
    tenantPicker: "Tenant",
    pickTenant: "Choose a tenant…",
  },
  filters: {
    search: "Search actor, action, target, IP…",
    searchLabel: "Search audit events",
    actorLabel: "Actor type",
    actors: { all: "All actors", staff: "Staff", tenant: "Tenant", system: "System" },
    categoryLabel: "Category",
    allCategories: "All categories",
    rangeLabel: "Time range",
    ranges: { "24h": "Last 24 hours", "7d": "Last 7 days", "30d": "Last 30 days", all: "All time", custom: "Custom range…" },
    from: "From",
    to: "To",
  },
  categories: {
    impersonation: "Impersonation",
    tenants: "Tenants",
    plans: "Plans",
    billing: "Billing",
    developer: "API keys",
    models: "Models & routing",
    staff: "Staff & access",
    security: "Security",
    knowledge: "Knowledge",
    agents: "Agents",
    settings: "Settings",
    system: "System",
    support: "Support",
    audit: "Audit",
    admin: "Admin reads",
  },
  table: {
    colTime: "Timestamp (PHT)",
    colActor: "Actor",
    colRole: "Role",
    colAction: "Action",
    colTarget: "Target",
    colIp: "IP",
    colDetails: "Details",
    details: "Details",
    detailsFor: "Details for {{action}} at {{time}}",
    actorTypes: { staff: "Staff", tenant: "Tenant", system: "System", end_user: "End user", api_key: "API key" },
    unknownActor: "Unknown",
    showing_one: "Showing {{count}} event",
    showing_other: "Showing {{count}} events",
    page: "Page {{page}}",
    newer: "Newer",
    older: "Older",
    emptyTitle: "No events match",
    emptyBody: "Try a wider time range or clear the filters.",
    clearFilters: "Clear filters",
  },
  sheet: {
    loading: "Loading event…",
    actor: "Actor",
    target: "Target",
    ip: "IP address",
    category: "Category",
    impersonatedBy: "Impersonated by",
    change: "Change (JSON diff)",
    noChange: "No field changes recorded for this event.",
    diffLabel: "JSON diff of the change",
    copy: "Copy diff",
    copied: "Diff copied",
    integrity: "Integrity",
    eventId: "event_id",
    hashesNote: "Hash, previous hash, user agent and trace are stored with the event but not exposed by the API yet.",
    moreFromActor: "More from this actor",
    done: "Done",
  },
} as const;
